import React, { useState } from "react";
import { Link } from "react-router-dom";
import MobileMenu from "./mobileMenu";

import { FaBars } from "react-icons/fa";

const NAV_LINKS = [
  {
    name: "Features",
    linkPath: "#Features",
  },
  {
    name: "About",
    linkPath: "#About",
  },
  {
    name: "Tokenomics",
    linkPath: "#Tokenomics",
  },
  {
    name: "Advantages",
    linkPath: "#Advantages",
  },
];

export default function Navbar() {
  const [menuShow, setMenuShow] = useState(false);

  const HandleClick = () => {
    setMenuShow(true);
  };

  return (
    <div className="fixed w-full z-[999] lg:p-0 p-3">
      <nav className="md:px-10 px-5 md:py-6 py-2 flex items-center justify-between lg:bg-transparent bg-[#000000b4] rounded-3xl  ">
        <div>
          <Link to="/">
            <img
              src="/images/logo.png"
              alt="logo"
              className="md:w-[15vw] w-[30vw]"
            />
          </Link>
        </div>
        <div className="lg:flex items-center gap-10 hidden">
          <ul className="flex items-center gap-14 bg-black border border-[#282828] px-10 py-[14px] rounded-3xl">
            {NAV_LINKS.map((item, index) => (
              <li key={index} className="font-light">
                <Link hrefLang={item.linkPath}>{item.name}</Link>
              </li>
            ))}
            <li className="font-light">
              <a href="">Whitepaper</a>
            </li>
          </ul>

          <div className="flex items-center gap-2">
            <a href="https://t.me/VocalAiPortal">
              <img src="images/t.png" alt="" className="w-[4vw]" />
            </a>
            <a href="x.com/VocalAiETH">
              <img src="images/x.png" alt="" className="w-[4vw]" />
            </a>
          </div>
          <div className="lg:flex items-center gap-2 hidden">
            <a href="">
              <button class="btn2 px-14 py-4 rounded-full">Buy Now</button>
            </a>
          </div>
        </div>

        <div className="lg:hidden block relative pt-2">
          <button onClick={HandleClick}>
            {" "}
            <FaBars />
          </button>
        </div>
      </nav>
      <div className="animation">
        {menuShow && <MobileMenu setMenuShow={setMenuShow} />}
      </div>
    </div>
  );
}
